import React, {useContext, useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import UnfoldLessOutlinedIcon from '@material-ui/icons/UnfoldLessOutlined';
import UnfoldMoreOutlinedIcon from '@material-ui/icons/UnfoldMoreOutlined';
import VisibilityOffOutlinedIcon
    from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import FilterFramesOutlinedIcon from '@material-ui/icons/FilterFramesOutlined';
import DeleteOutlineOutlinedIcon
    from '@material-ui/icons/DeleteOutlineOutlined';
import {makeStyles} from "@material-ui/styles";
import NGLContext from '../../NGLContext'
import {Dialog} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import {superpose} from "ngl";

const useStyles = makeStyles(theme => ({
    button: {
        // margin: theme.spacing.unit,
        outline: 'none !important',
    },
    alertActions: {
        justifyContent: "center"
    },
    formControl: {
        display: 'none',
    },
    selectMenu: {
        display: 'none',
    },
    form: {
        display: 'inline'
    },
    close: {
        padding: theme.spacing(0.5),
    },
}));


function FoldButton() {
    const [fold, setFold] = useState(false);
    const classes = useStyles();
    const context = useContext(NGLContext);
    useEffect(() => {
        if (context.stage) {
            context.handleComponentListFold(fold);
        }
    }, [fold]);
    return <Tooltip title="Fold/Unfold"><IconButton
        aria-label="delete"
        size="small"
        className={classes.button}
        onClick={() => setFold(prevFold => !prevFold)}
    >{
        fold ? (
            <UnfoldMoreOutlinedIcon fontSize="inherit"/>
        ) : (
            <UnfoldLessOutlinedIcon fontSize="inherit"/>
        )
    }
    </IconButton></Tooltip>
};

function VisibilityButton() {
    const classes = useStyles();
    const context = useContext(NGLContext);
    const structureComponent = context.stage ? context.stage.compList[context.componentIndex] : null;
    const [visible, setVisibility] = useState(true);
    const handleClick = () => {
        setVisibility(prevVisibility => !prevVisibility);
    };
    // Callback function with useeffect if the stage has been loaded
    useEffect(() => {
        if (context.stage) {
            context.stage.compList.map((compItem, compIdx) => {
                compItem.setVisibility(visible)
            });
        }
    }, [visible]);
    return <Tooltip title="Show/Hide"><IconButton
        aria-label="delete"
        size="small"
        className={classes.button}
        onClick={handleClick}
    >{
        visible ? (
            <VisibilityOutlinedIcon fontSize="inherit"/>
        ) : (
            <VisibilityOffOutlinedIcon fontSize="inherit"/>
        )
    }
    </IconButton></Tooltip>
};

function FilterFrameListButton() {
    const classes = useStyles();
    const context = useContext(NGLContext);
    const [frames, setFrames] = useState('');
    const [anchorSelect, setAnchorSelect] = useState(null);
    const structureComponent = context.stage ? context.stage.compList[context.componentIndex] : null;
    const handleChange = event => {
        setFrames(event.target.value);
        structureComponent.setSelection("/" + event.target.value);
    };
    return <form autoComplete="off" className={classes.form}>
        <Tooltip title="Select model(s)">
                                           <IconButton
                aria-label="select-frames"
                size="small"
                className={classes.button}
                onClick={(event) => setAnchorSelect(event.currentTarget)}
            >
                <FilterFramesOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </Tooltip>
        <FormControl className={classes.formControl}>
            <Select
                autoWidth
                className={classes.selectMenu}
                displayEmpty={false}
                open={Boolean(anchorSelect)}
                onClose={() => setAnchorSelect(null)}
                value={frames}
                onChange={handleChange}
                MenuProps={{
                    anchorEl: anchorSelect,
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5,
                            width: 100,
                        },
                    },
                }}
                inputProps={{
                    name: 'frame',
                    id: 'select-frames-button',
                }}
            >
                <MenuItem value={""}>all</MenuItem>
                {context.stage && structureComponent.structure.modelStore.count && Array.from({length: structureComponent.structure.modelStore.count}, (_, id) => ({id})).map((modelItem) =>
                    <MenuItem
                        value={modelItem.id.toString()}
                        key={modelItem.id.toString()}>
                        {modelItem.id + 1}
                    </MenuItem>
                )}
            </Select>
        </FormControl>
    </form>
};

function SuperposeButton() {
    const classes = useStyles();
    const context = useContext(NGLContext);
    const [frames, setFrames] = useState('');
    const [anchorSelect, setAnchorSelect] = useState(null);
    const handleChange = event => {
        const superStructure = context.stage ? context.stage.compList[event.target.value] : null;
        if (context.stage) {
            context.stage.compList.map((compItem, compIdx) => {
                const aliStructure = context.stage.compList[compIdx];
                superpose(aliStructure.structure, superStructure.structure, true);
                aliStructure.updateRepresentations({position: true});
            });
            context.stage.autoView(1000)
        }
    };
    return <form autoComplete="off" className={classes.form}>
        <Tooltip title="Align all to">
            <IconButton
                aria-label="select-frames"
                size="small"
                className={classes.button}
                onClick={(event) => setAnchorSelect(event.currentTarget)}
            >
                <LayersOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </Tooltip>
        <FormControl className={classes.formControl}>
            <Select
                autoWidth
                className={classes.selectMenu}
                displayEmpty={false}
                open={Boolean(anchorSelect)}
                onClose={() => setAnchorSelect(null)}
                value={frames}
                onChange={handleChange}
                MenuProps={{
                    anchorEl: anchorSelect,
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5,
                            // width: 100,
                        },
                    },
                }}

                inputProps={{
                    name: 'frame',
                    id: 'select-frames-button',
                }}
            >
                {context.stage && context.stage.compList.map((compItem, idx) =>
                    <MenuItem
                        value={idx}
                        key={compItem.name}>
                        {compItem.name}
                    </MenuItem>
                )}
            </Select>
        </FormControl>
    </form>
};

function DeleteButton() {
    const classes = useStyles();
    const [alert, handleAlert] = useState(false);
    const [snack, setSnack] = useState(false);
    const context = useContext(NGLContext);
    const structureComponent = context.stage ? context.stage.compList[context.componentIndex] : null;
    const deleteComp = () => {
        if (structureComponent && context.stage.compList.length > 1) {
            context.handleCompListItemClick(context.componentIndex - 1);
            context.stage.removeComponent(structureComponent);
        } else if (context.stage.compList.length <= 1) {
            setSnack(true)
        }
        handleAlert(false);
    };

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnack(false);
    };
    return <React.Fragment>
        <Tooltip title="Delete">
            <IconButton
                aria-label="delete"
                size="small"
                className={classes.button}
                onClick={() => handleAlert(true)}
            >
                <DeleteOutlineOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </Tooltip>
        <Dialog
            open={alert}
            onClose={() => handleAlert(false)}
            aria-labelledby="alert-delete-component-dialog"
        >
            <DialogTitle>{`Delete structure component ${context.stage ? context.stage.compList[context.componentIndex].name : ''} ?`}</DialogTitle>
            <DialogActions
                className={classes.alertActions}
            >
                <IconButton
                    onClick={deleteComp}
                    color="primary"
                    className={classes.button}
                >
                    <DoneOutlinedIcon fontSize="inherit"/>
                </IconButton>
                <IconButton
                    onClick={() => handleAlert(false)}
                    color="secondary"
                    autoFocus
                    className={classes.button}
                >
                    <CloseOutlinedIcon fontSize="inherit"/>
                </IconButton>
            </DialogActions>
        </Dialog>
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open={snack}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            ContentProps={{
                'aria-describedby': 'delete-comp-warning',
            }}
            message={<span id="delete-comp-warning">Need more than one structure in order to delete</span>}
            action={[
                //<Button key="undo" color="secondary" size="small"
                // onClick={handleSnackClose}>
                // UNDO
                // </Button>,
                <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    className={classes.close}
                    onClick={handleSnackClose}
                >
                    <CloseIcon/>
                </IconButton>,
            ]}
        />
    </React.Fragment>
};

export default function ComponentHeader() {
    const context = useContext(NGLContext);
    return <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
    >
        <Grid item>Structures</Grid>
        {context.stage &&
        <Grid item>
            <FoldButton/>
            <VisibilityButton/>
            <FilterFrameListButton/>
            <SuperposeButton/>
            <DeleteButton/>
        </Grid>
        }
    </Grid>
};